const FIELDS = [
  { id: 'ip_name', label: 'Наименование ИП', icon: 'ri-briefcase-line', placeholder: 'ИП Иванов Иван Иванович' },
  { id: 'inn', label: 'ИНН', icon: 'ri-id-card-line', placeholder: '123456789012 (12 цифр)' },
  { id: 'ogrnip', label: 'ОГРНИП', icon: 'ri-file-list-2-line', placeholder: '123456789012345 (15 цифр)' },
  { id: 'bank', label: 'Наименование банка', icon: 'ri-bank-line', placeholder: 'ПАО Сбербанк' },
  { id: 'bik', label: 'БИК банка', icon: 'ri-building-line', placeholder: '044525225 (9 цифр)' },
  { id: 'account', label: 'Расчётный счёт', icon: 'ri-currency-line', placeholder: '40802810938000012345 (20 цифр)' },
  { id: 'corr_account', label: 'Корр. счёт', icon: 'ri-exchange-funds-line', placeholder: '30101810400000000225 (20 цифр)' },
];

export default function MyRequisites() {
  return (
    <div className="max-w-2xl">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-1">Мои реквизиты</h2>
        <p className="text-slate-500 text-sm">Реквизиты для начисления выплат</p>
      </div>

      {/* Locked banner */}
      <div className="flex items-start gap-3 bg-amber-500/8 border border-amber-500/20 rounded-2xl px-5 py-4 mb-6">
        <span className="w-5 h-5 flex items-center justify-center text-amber-400 flex-shrink-0 mt-0.5">
          <i className="ri-lock-fill text-base" />
        </span>
        <div>
          <p className="text-sm font-semibold text-amber-400 mb-1">Раздел заблокирован</p>
          <p className="text-sm text-amber-400/70 leading-relaxed">
            Заполнение реквизитов станет доступно после завершения процесса оформления.
            Обратитесь к вашему менеджеру для получения дальнейших инструкций
          </p>
        </div>
      </div>

      {/* Fields */}
      <div className="space-y-4">
        {FIELDS.map((field) => (
          <div key={field.id} className="relative">
            <label className="block text-xs font-medium text-slate-600 mb-2">
              {field.label}
            </label>
            <div className="relative">
              <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-slate-700">
                <i className={`${field.icon} text-base`} />
              </span>
              <input
                type="text"
                disabled
                placeholder={field.placeholder}
                className="w-full bg-[#1a1d28]/40 border border-dashed border-[#2a2d3e] rounded-xl pl-11 pr-12 py-3.5 text-sm text-slate-700 placeholder-slate-800 cursor-not-allowed"
              />
              <span className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-amber-600">
                <i className="ri-lock-2-line text-sm" />
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6">
        <button
          disabled
          className="w-full flex items-center justify-center gap-2 bg-[#1a1d28]/50 border border-dashed border-[#2a2d3e] text-slate-700 rounded-xl py-3.5 text-sm cursor-not-allowed whitespace-nowrap"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-lock-2-line" />
          </span>
          Сохранить реквизиты (недоступно)
        </button>
      </div>
    </div>
  );
}
